import script from "./GameLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameLayout.vue?vue&type=script&setup=true&lang=ts"

import "./GameLayout.vue?vue&type=style&index=0&id=02b80fea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b80fea"]])

export default __exports__